export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";